import React from "react";

import _ from "lodash";

import { useClassNameExtenderContext } from "commons/context/classNameExtender";

function useClassNameExtenderPull({ key }: { key: string }) {
    const classNames = useClassNameExtenderContext();

    return React.useMemo(() => {
        if (key in classNames) {
            return _.orderBy(classNames[key], "priority", "asc")
                .map((item) => item.className)
                .join(" ");
        } else {
            return "";
        }
    }, [classNames, key]);
}

export default useClassNameExtenderPull;
